import { dataFetcher } from 'core/services/requestHandler';   
import { requestHandler } from 'core/services/httpRequest';

const getNotificationList = async (data = {}, config = {}) => {
  return dataFetcher('GetNotificationList', data, {...config});
};


export async function downloadTermConditionFile(options={}) {
  const configs = { headers: {'accept': "*/*"} };
  return requestHandler.FILE({url: `/notification/downloadTerms`, configs}, options);
}

export { getNotificationList };
